module.exports = __webpack_public_path__ + "static/media/payment-method-default.0a0be40c.svg";